document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {

      var productItems = '';
      var productContainer = '';
      
      if (window.location.pathname === '/') {
        productContainer = document.querySelector('.main-content .grid.grid--layout.grid-4.grid-portable-3.grid-lap-2.grid-tiny-1');
        
        // Ensure the container exists before proceeding
        if (!productContainer) return;
        
        // Get all product items within the main-content
        productItems = document.querySelectorAll('.main-content .product-item');   
        
        //console.log('1yes');
      } else {
        productContainer = document.querySelector('#main-collection-product-grid');

        // Ensure the container exists before proceeding
        if (!productContainer) return;
        
        // Get all product items within the main-content
        productItems = document.querySelectorAll('#main-collection-product-grid .product-item');   
                                             
        //console.log('2no');
      }
      
      // Separate items based on badge content
        const soldOutItems = [];
        const itemsWithBadges = [];
        const otherItems = [];

        productItems.forEach(item => {
            const badges = item.querySelectorAll('.product-item__badge');
            let isSoldOut = false;
            let hasBadge = false;

            badges.forEach(badge => {
                if (badge.textContent.trim() === 'Sold Out') {
                    isSoldOut = true;
                } else if (badge.textContent.trim() !== '') {
                    hasBadge = true;
                }
            });

            if (isSoldOut) {
                soldOutItems.push(item);
            } else if (hasBadge) {
                itemsWithBadges.push(item);
            } else {
                otherItems.push(item);
            }
        });

        // Log the separated items for debugging
        //console.log('Items with badges:', itemsWithBadges.length, itemsWithBadges);
        //console.log('Other items:', otherItems.length, otherItems);
        //console.log('Sold out items:', soldOutItems.length, soldOutItems);

        // Clear the container
        productContainer.innerHTML = '';

        // Append items with badges first
        itemsWithBadges.forEach(item => {
            productContainer.appendChild(item);
        });

        // Append other items next
        otherItems.forEach(item => {
            productContainer.appendChild(item);
        });

        // Append sold out items at the end
        soldOutItems.forEach(item => {
            productContainer.appendChild(item);
        });

        // Log final container contents for debugging
        //console.log('Final container content:', productContainer.innerHTML);

      
      
     
    }, 100);
});
